import { ReactNode, useState } from 'react';
import { SxProps, Theme } from '@mui/material';

import { MplTabLabelSkeleton } from './MplTabLabelSkeleton';
import {
	SkeletonWrapper,
	TabContent,
	TabSkeletonItem,
} from './MplTabsSkeleton.styles';

export interface MplTabsSkeletonProps {
	tabsCount?: number;
	initialActiveIndex?: number;
	withIcon?: boolean;
	icons?: ReactNode[];
	tabSx?: SxProps<Theme>;
	indicatorColors?: string[];
	testId?: string;
}

export const MplTabsSkeleton = ({
	tabsCount = 3,
	initialActiveIndex = 0,
	withIcon = false,
	icons,
	tabSx,
	indicatorColors,
	testId,
}: MplTabsSkeletonProps) => {
	const [activeIndex, setActiveIndex] = useState(initialActiveIndex);

	return (
		<SkeletonWrapper data-testid={testId}>
			{Array.from({ length: tabsCount }).map((_, index) => {
				const isActive = index === activeIndex;
				const iconNode = icons?.[index];
				const showIcon = withIcon || !!iconNode;
				const indicatorColor = indicatorColors?.[index];

				return (
					<TabSkeletonItem
						key={index}
						sx={tabSx}
						isActive={isActive}
						indicatorColor={indicatorColor}
						onClick={() => setActiveIndex(index)}
					>
						<TabContent sx={{ opacity: isActive ? 1 : 0.6 }}>
							{showIcon &&
								(iconNode ?? (
									<MplTabLabelSkeleton
										variant="rounded"
										width={16}
										height={16}
									/>
								))}
							<MplTabLabelSkeleton />
						</TabContent>
					</TabSkeletonItem>
				);
			})}
		</SkeletonWrapper>
	);
};
